import React from 'react';
import Header from '../components/Header';
import Directors from '../components/Directors';
import Footer from '../components/Footer';

const DirectorsPage = () => {
  return (
    <div className="App">
      <Header />
      <Directors />
      <Footer />
    </div>
  );
};

export default DirectorsPage;

